export * from './baSlimScroll.directive';



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/theme/directives/baSlimScroll/index.ts